import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import {
  HoveredLeftMenuDirective,
  MenuOptions,
} from '../../directives/hoveredLeftMenu.directive';
import { MenuTool } from '../../interfaces/MenuTool.interface';

@Component({
  selector: 'z-apps-tools-menu',
  standalone: true,
  imports: [CommonModule, HoveredLeftMenuDirective],
  templateUrl: './apps-tools-menu.component.html',
  styleUrls: ['./apps-tools-menu.component.scss'],
})
export class AppsToolsMenuComponent {
  tools = input.required<MenuTool[]>();
  menuOptions: MenuOptions = {
    autoClose: false,
    menuWidth: '260px',
  };

  openTool(url: string) {
    window.open(url, '_blank');
  }
}
